/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesextracting1Inputs */

const en_filesextracting1 = /** @type {(inputs: Filesextracting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading…`)
};

const pt_filesextracting1 = /** @type {(inputs: Filesextracting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A ler…`)
};

/**
* | output |
* | --- |
* | "Reading…" |
*
* @param {Filesextracting1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesextracting1 = /** @type {((inputs?: Filesextracting1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesextracting1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesextracting1(inputs)
	return pt_filesextracting1(inputs)
});
export { filesextracting1 as "filesExtracting" }